import { GenericStoreAsyncMethod } from 'src/util/mobx/generic-store/decorator/async-method.decorator'
import { GenericStore } from 'src/util/mobx/generic-store/generic.store'
import { createStore } from 'src/util/mobx/generic-store/store-creator'
import { downloadReport, getMyDashboard, getUserDashboard } from '../api/dashboard'
import { MyDashboard, DownloadReportFormData } from '../model/dashboard-model'

export class dashboardStore extends GenericStore {
  myDashboard: MyDashboard | undefined
  userDashboard: MyDashboard | undefined

  constructor() {
    super('dashboardStore')

    super.observe(this)
    super.persist({ encrypt: false })
  }

  reset() {
    this.myDashboard = undefined
    this.userDashboard = undefined
  }

  @GenericStoreAsyncMethod()
  async downloadReport(reportData: DownloadReportFormData) {
    const data = await downloadReport(reportData)
    // Determine mime type based on report type
    const mimeType = reportData.reportType === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    // Create and download the file
    const blob = new Blob([data], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    // Generate filename with timestamp
    const timestamp = new Date()
      .toISOString()
      .split('T')[0]
    const fileExtension = reportData.reportType === 'pdf' ? 'pdf' : 'xlsx'
    a.download = `report-${timestamp}.${fileExtension}`
    document.body.appendChild(a)
    a.click()
    a.remove()
    window.URL.revokeObjectURL(url)
    
    return data
  }

  @GenericStoreAsyncMethod()
  async getMyDashboard() {
    const data = await getMyDashboard()
    this.myDashboard = data
  }

  @GenericStoreAsyncMethod()
  async getUserDashboard(userId: string) {
    const data = await getUserDashboard(userId)
    this.userDashboard = data
  }
}

export const {
  storeInstance: dashboardStoreInstance,
  useStore: useDashboardStore,
} = createStore(new dashboardStore())
